import { render, staticRenderFns } from "./zBusca.vue?vue&type=template&id=56ae014b&scoped=true&"
import script from "./zBusca.vue?vue&type=script&lang=js&"
export * from "./zBusca.vue?vue&type=script&lang=js&"
import style0 from "./zBusca.vue?vue&type=style&index=0&id=56ae014b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ae014b",
  null
  
)

export default component.exports